import React from 'react';
import $ from "jquery";

import Storage from './Storage.js';

class AdminMenu extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
    };
  }

  handleSectionClick = (e, key) => {
    if(e.button === 0) {
      $(document).trigger("changePage", [key]);
    } else if (e.button === 1) {
      e.preventDefault();
      $(document).trigger("openPage", [key]);
    }
  }

  render = () => {
    var menuItems = [];
    for (let i = 0; i < this.props.items.length; i++) {
      let key = this.props.items[i];
      menuItems.push(
        <li key={key} className={this.props.selected === key ? "selected" : ""}>
          <a
            onMouseDown={(e) => this.handleSectionClick(e, key)}
          >{Storage.getConfig(key).config.title}</a>
        </li>
      );
      // separators
      if (this.props.items[i+1]) {
        let prevKey = this.props.items[i+1];
        if (Storage.getConfig(key).section !== Storage.getConfig(prevKey).section) {
          menuItems.push(
            <li className="separator" key={"separator"+i}/>
          );
        }
      }
    }
    
    return (
      <div className="adminMenu customScrollBar">
        <ul className="nav nav-pills nav-stacked">
          {menuItems}
        </ul>
        
        <ul className="nav nav-pills nav-stacked">
          <li>
            <a onClick={this.props.onLogout}
            >Выход</a>
          </li>
        </ul>
      </div>
    );
  }
}

export default AdminMenu;



// WEBPACK FOOTER //
// ./src/AdminMenu.js